export default {
  intake: {
    eventRestricted: '该订货会尚未开通接收，请联系管理员核对测试范围。',
    title: '订货接收记录',
    description: '查看订货结果与款式任务。测试期间可修正资料，每次修改保留原因和履历。',
    allBrands: '全部可见品牌',
    search: '款号或订货会',
    empty: '尚未接收订货结果',
    event: '订货会',
    totalQty: '订货总量',
    state: '接收状态',
    receivedAt: '接收时间',
    received: '已接收',
    corrected: '已修正',
    cancelled: '已撤回',
    openTask: '查看款式任务',
    testNotice:
      '测试期间可修正订货资料。保存后 Tech Pack 需重新确认；已提交或已批准的设计回到草稿。重推不会覆盖人工修改。',
    closedNotice: '订货资料按上游结果保留。如需调整，请联系商品企划与系统管理员。',
    current: '当前资料',
    original: '原始推送',
    history: '修改履历',
    launchMonth: '销售月',
    price: '预计售价（CNY）',
    grade: '最终等级',
    genderBOY: '男',
    genderGIRL: '女',
    genderUNISEX: '男女共用',
    dimensionsHint:
      '删除颜色或尺码前，系统会检查其是否已被设计、材料或尺寸资料使用。已使用的项目需先处理相关资料。',
    colorNumber: '色号',
    colorCode: '颜色代码',
    colorName: '颜色名称',
    addColor: '增加颜色',
    sizes: '尺码',
    quantities: '订货数量',
    qty: '数量',
    reason: '修改原因',
    reasonRequired: '请填写至少 3 个字的原因',
    save: '保存修正',
    saved: '已保存修正，请按提示重新确认',
    discard: '有尚未保存的修正，确认放弃吗？',
    noHistory: '尚无修改记录',
    quantityChanges: '查看数量变化',
    before: '修改前',
    after: '修改后',
    qtyChange: '订货总量：{before} → {after}',
    cancelTitle: '撤回测试接收',
    cancelExplain:
      '本次撤回涉及以下款号：{styles}。整批任务将作废，设计资料和原始推送仍会保留。核对后可使用新批次重新推送。请填写撤回原因。',
    cancelConfirm: '撤回这批测试接收',
    notConfigured: '订货对接尚未开通，请联系管理员',
    keyInvalid: '接收凭据无效，请核查对接配置',
    invalid: '订货资料检查未通过，请在上游修正后重试',
    batchMismatch: '推送批次号不一致',
    batchConflict: '该批次已使用，不能更换内容',
    snapshotConflict: '同一定稿记录的内容已改变，请核查或撤回测试接收后重新推送',
    cancelledRetry: '这批测试接收已撤回，请使用新批次重新推送',
    checkExpired: '检查结果已过期或负责人有变，请重新检查后推送',
    notFound: '找不到这条订货接收记录',
    changed: '资料已被其他人修改，请刷新后重新核对',
    correctionClosed: '测试资料修正现已关闭',
    dimensionInUse: '要删除的颜色或尺码已被使用，请先处理相关设计、材料或尺寸资料',
    externalTransfer: '这份资料已发送或正在发送到 SAP，不能直接修正或撤回测试接收',
    rateLimit: '请求较多，请稍后再试',
    field: {
      styleName: '款式名称',
      productYear: '产品年',
      season: '季节',
      launchMonth: '销售月',
      tagPrice: '预计售价（CNY）',
      finalGrade: '最终等级',
    },
  },
};
